import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
  MetacomConnectionResponse,
  MetacomMomentResponse,
} from "@core/models/api.response";
import { MetacomDataDTO, MetacomMomentDTO } from "@core/models/dto.models";
import { LoginState } from "@core/models/login.interface";

import { StoreDetailsState } from "@core/models/store.interface";
import { environment } from "@env/environment";
import { Store } from "@ngrx/store";
import { selectStoreDetails } from "@shared/store/store-details/selectors";
import { selectLoginUserData } from "app/features/sessions/login/store/selectors";
import {
  catchError,
  combineLatest,
  map,
  Observable,
  of,
  switchMap,
  take,
  throwError,
} from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MetacomService {
  constructor(
    private http: HttpClient,
    private store: Store<{
      storeDetails: StoreDetailsState;
      login: LoginState;
    }>,
    private dialog: MatDialog
  ) {}

  setupMetacomConnection(
    metacomDetails: MetacomDataDTO
  ): Observable<MetacomConnectionResponse> {
    const body = new URLSearchParams();
    body.set("hash", metacomDetails.authHash);

    // return of({ connected: true }); //Remove

    return this.http
      .post<any>(metacomDetails.authEndPoint, body.toString(), {
        headers: new HttpHeaders({
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        }),
        observe: "response",
      })
      .pipe(
        map((response) => {
          if (response.status === 200) {
            return { connected: true };
          } else {
            return {
              connected: false,
              message: response.status.toString(),
            };
          }
        }),
        catchError((error) => {
          return throwError(() => new Error(error.status.toString()));
        })
      );
  }

  createMetacomMoment(): Observable<MetacomMomentResponse> {
    return combineLatest([
      this.store.select(selectStoreDetails),
      this.store.select(selectLoginUserData),
    ]).pipe(
      take(1),
      switchMap(([storeDetails, userData]) => {
        if (!storeDetails || !userData) {
          return throwError(() => new Error("Invalid store details or UID"));
        }

        // Prepare request payload
        const body: MetacomMomentDTO = {
          uid: userData.uid!,
          storeId: storeDetails.branch,
        };

        // Make the HTTP request
        return this.http
          .post<MetacomMomentResponse>(`${environment.apiUri}/moment`, body, {
            headers: new HttpHeaders({
              Authorization: `Bearer ${userData.access_token!}`,
            }),
          })
          .pipe(
            catchError((error) => {
              return throwError(
                () =>
                  new Error(
                    error.error?.message ??
                      error.message ??
                      "An unknown error has occurred, please try again."
                  )
              );
            })
          );
      })
    );
  }
}
